"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.join.js");
var _utils = require("../utils");
var _index = require("./api/index");
var _toast = _interopRequireDefault(require("../toast"));
var _actionPicker = _interopRequireDefault(require("../action-picker"));
var _use = (0, _utils.use)('platform-bch-entry'),
  sfc = _use[0],
  bem = _use[1];
var adapter;
if (!_utils.isServer) {
  adapter = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}
var _default = sfc({
  props: {
    title: String,
    // 标题
    type: String,
    // 样式1/2/3 embed/bottom/issus
    questionnaireId: String,
    // 问券ID
    extend: Object,
    // 扩展属性（商品信息） https://doc.weixin.qq.com/doc/w3_AFkApwbSAOgjgzxetuqQbquj0pkY4?scode=AJ4AfQfgAAwfBMVTarAFoAqwYoAOM
    // 打开问券页方式。端内：不填写，则在当前webview打开前端模拟半层弹窗 
    // 1、新开全屏webview 
    // 2、location.href跳转，不开启新webview，在当前webview内打开【半层推荐使用】
    // 3、新开半屏webview。端外：统一打开前端模拟弹窗形式，如果端外不想用模拟弹窗，可以设置为1强制打开新的页面
    preview: false,
    popHeight: {
      type: Number,
      default: 80
    },
    position: {
      type: String,
      default: 'bottom'
    },
    multiple: Boolean,
    canBack: Number,
    getContainer: String,
    scrollContainer: String,
    openType: Number,
    outAppOpenType: Number // 1、前端模拟弹窗【默认】 2、新开页面
  },
  data: function data() {
    return {
      isComplete: null,
      // 1 已完成 0 未完成
      isHelp: null,
      // 0 无帮助 1 有帮助
      isShow: 0,
      // 0 不展示入口 1展示入口
      showPop: false,
      iframeUrl: '',
      componentType: {
        'embed': '1',
        'bottom': '0',
        'issus': '2'
      },
      currentContainerId: null,
      scrollContainerEl: null,
      screenHeight: 0,
      targetTop: 0,
      hasExposure: false,
      customPopStyle: {}
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.removeScrollListener();
  },
  mounted: function mounted() {
    var _this = this;
    this.currentContainerId = "platform-bch-entry-" + Date.now();
    this.computedRightStyle();
    if (this.$slots.default) {
      this.isShow = 1;
      return null;
    }
    this.getEntrance();
    if (this.multiple) {
      if (!window.platformBchEntryRegisterPageCallbackList) {
        window.platformBchEntryRegisterPageCallbackList = [];
      }
      window.platformBchEntryRegisterPageCallbackList.push(function () {
        _this.getEntrance('re');
      });
    }
    if (adapter.in('zz') || adapter.in('zlj')) {
      adapter.registerPageCallback({
        useOrigin: true,
        callback: function callback(res) {
          if (res.pageState && Number(res.pageState) === 4) {
            if (_this.multiple) {
              window.platformBchEntryRegisterPageCallbackList.forEach(function (item) {
                item();
              });
            } else {
              _this.getEntrance('re');
            }
          }
        }
      });
      // adapter.wrap('onShow')({}, (res) => {
      //   this.getEntrance();
      // })
      // document.addEventListener('visibilitychange', () => {
      //   if (!document.hidden) {
      //     this.getEntrance('re')
      //   }
      // })
      // if (this.multiple) {
      //   adapter.wrap('onShow')({}, (res) => {
      //     this.getEntrance('re');
      //   })
      // } else {
      //   adapter.registerPageCallback({
      //     useOrigin: true,
      //     callback: (res) => {
      //       if (res.pageState && (Number(res.pageState) === 4)) {
      //         this.getEntrance('re')
      //       }
      //     },
      //   });
      // }
    } else {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
          _this.getEntrance('re');
        }
      });
    }
    // adapter.registerPageCallback({
    //   useOrigin: adapter.in('zz') || adapter.in('zlj'),
    //   callback: (res) => {
    //     if (res.pageState === 4) {
    //       this.getEntrance('re')
    //     }
    //   },
    // });
    window.addEventListener('message', function (_ref) {
      var data = _ref.data;
      // 调查问券完成提交后执行
      if (_this.$slots.default) return null;
      var _ref2 = data || {},
        type = _ref2.type,
        payload = _ref2.payload;
      if (type === 'question_bch') {
        var status = payload.status;
        if (status === 0) {
          _this.$refs.actionPicker.close();
          (0, _toast.default)('感谢您的反馈');
          if (_this.type === 'embed') {
            _this.isShow = 0;
          }
          if (_this.type === 'bottom') {
            _this.isComplete = 1;
            _this.isHelp = 0;
          }
        }
      }
    });
  },
  methods: {
    computedRightStyle: function computedRightStyle() {
      if (this.position !== 'right') return null;
      if ((adapter.in('zz') || adapter.in('zlj')) && [2, 3].includes(this.openType)) return null;
      var top = 100 - this.popHeight / 2;
      this.customPopStyle = {
        top: top + 1 + "%",
        width: '100%',
        'max-width': '100%',
        'max-height': '100%',
        'justify-content': 'flex-start',
        'border-bottom-left-radius': 'unset',
        'border-top-right-radius': '16px',
        'border-top-left-radius': '16px'
      };
    },
    urlAddQueryOrFormatHash: function urlAddQueryOrFormatHash(url, key, value) {
      var urlSplit = url.split('?');
      var query = [];
      var hash = [];
      urlSplit.forEach(function (item, index) {
        if (index === 0) return null;
        if (item.indexOf('#') > -1) {
          var hashSplit = item.split('#');
          var otherQuery = hashSplit[1].split('&');
          query.push(hashSplit[0]);
          query.push(otherQuery[1]);
          hash.push(otherQuery[0]);
        } else {
          query.push(item);
        }
      });
      if (key && value) {
        query.push(key + "=" + value);
      }
      var newUrl = urlSplit[0] + "?" + query.join('&') + "#" + hash[0];
      return newUrl;
    },
    dealHalfVerQuery: function dealHalfVerQuery(url) {
      var urlSplit = url.split('?');
      var newUrl = urlSplit[0] + "?wvCornerRadius=32&wvAnimateDirection=" + (this.position === 'right' ? 'r2l' : '') + "&wvHalfVer=v2&wvHeightRate=" + (this.popHeight / 100 || 0.8) + "&" + urlSplit[1] + "&" + (urlSplit[2] || '');
      return this.urlAddQueryOrFormatHash(newUrl);
    },
    urlAddCommonQuery: function urlAddCommonQuery(url) {
      if (!url) return '';
      var urlSplit = url.split('?');
      var newUrl = urlSplit[0] + "?v=" + Date.now() + "&" + urlSplit[1] + "&" + (urlSplit[2] || '');
      if (this.openType === 2 || this.canBack && Number(this.canBack) === 1) {
        // 为了后续页面展示返回箭头用
        return this.urlAddQueryOrFormatHash(newUrl, 'canBack', '1');
      }
      return this.urlAddQueryOrFormatHash(newUrl);
    },
    getEntrance: function getEntrance(type) {
      var _this2 = this;
      return (0, _index.getbaichuanentrance)({
        questionnaireId: this.questionnaireId,
        componentType: this.componentType[this.type],
        extend: JSON.stringify(this.extend)
      }).then(function (res) {
        try {
          _this2.isComplete = Number(res === null || res === void 0 ? void 0 : res.isComplete);
          _this2.isHelp = Number(res === null || res === void 0 ? void 0 : res.isHelp);
          _this2.isShow = Number(res === null || res === void 0 ? void 0 : res.isShow);
          _this2.$emit('watchShow', Number(res === null || res === void 0 ? void 0 : res.isShow));
          if (type !== 're') {
            var resUrl = res.questionnaireUrl;
            // const resUrl = this.urlAddCommonQuery(res.questionnaireUrl)
            if (resUrl) {
              _this2.iframeUrl = resUrl;
            }
            if (_this2.type === 'embed' && _this2.isShow === 1) {
              // 固定入口不曝光
              _this2.listenerScroll(); // 发送曝光接口
            }
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    // reset() {
    //   // this.hasExposure = false
    //   // window.removeEventListener('scroll', this.listenerScrollFun);
    //   // this.getEntrance('re')
    // },
    getElementToPageTop: function getElementToPageTop(el, endEl) {
      if (endEl === void 0) {
        endEl = document.body;
      }
      if (el.parentElement && el.parentElement !== endEl) {
        return this.getElementToPageTop(el.parentElement, endEl) + el.offsetTop;
      }
      return el === null || el === void 0 ? void 0 : el.offsetTop;
    },
    removeScrollListener: function removeScrollListener() {
      window.removeEventListener('scroll', this.listenerScrollFun);
    },
    listenerScrollFun: function listenerScrollFun() {
      var _this$scrollContainer;
      if (this.hasExposure) return null;
      if ((((_this$scrollContainer = this.scrollContainerEl) === null || _this$scrollContainer === void 0 ? void 0 : _this$scrollContainer.scrollTop) || window.scrollY) + this.screenHeight > this.targetTop + 40) {
        this.hasExposure = true;
        this.pageReport(0);
        this.removeScrollListener();
      }
    },
    listenerScroll: function listenerScroll() {
      var _this3 = this;
      try {
        var target = document.querySelector("#" + this.currentContainerId);
        var scrollContainerEl = document.querySelector("#" + this.scrollContainer);
        this.scrollContainerEl = scrollContainerEl;
        if (!target) {
          return setTimeout(function () {
            return _this3.listenerScroll();
          }, 100);
        }
        if (!this.screenHeight) {
          if (scrollContainerEl) {
            this.screenHeight = scrollContainerEl.clientHeight;
          } else {
            this.screenHeight = Math.min(window.screen.height, window.innerHeight, window.screen.availHeight);
          }
        }
        if (!this.targetTop) {
          if (scrollContainerEl) {
            this.targetTop = this.getElementToPageTop(target, scrollContainerEl) || 0;
          } else {
            this.targetTop = this.getElementToPageTop(target) || 0;
          }
        }
        if (this.screenHeight > this.targetTop + 40) {
          this.pageReport(0);
        } else {
          var container = scrollContainerEl || window;
          container.addEventListener('scroll', this.listenerScrollFun);
        }
      } catch (error) {
        console.log('曝光报错:', error);
      }
    },
    pageReport: function pageReport(type) {
      var _this$extend, _this$extend2;
      return (0, _index.baichuanpagereport)({
        type: type,
        questionnaireId: this.questionnaireId,
        pageName: (_this$extend = this.extend) === null || _this$extend === void 0 ? void 0 : _this$extend.pageName,
        pgCateId: (_this$extend2 = this.extend) === null || _this$extend2 === void 0 ? void 0 : _this$extend2.pgCateId
      });
    },
    clickClose: function clickClose() {
      this.isShow = 0;
      this.pageReport(1);
      this.$emit('watchShow', 0);
    },
    clickUpBtn: function clickUpBtn() {
      var _this4 = this;
      if (this.type === 'bottom' && this.isComplete === 1) {
        // 提交后不可再点击
        return null;
      }
      this.pageReport(2).then(function (res) {
        (0, _toast.default)('感谢您的反馈');
        if (_this4.type === 'embed') {
          _this4.isShow = 0;
        }
        if (_this4.type === 'bottom') {
          _this4.isComplete = 1;
          _this4.isHelp = 1;
        }
      });
    },
    updateIframeUrl: function updateIframeUrl() {
      // 避免更新数据，url数据丢失
      if (this.$slots.default) {
        // slots时不请求接口，所以要填入默认值
        this.iframeUrl = "https://m.zhuanzhuan.com/common/uem/index.html?needHideHead=3&questionnaireId=" + this.questionnaireId + "&extend=" + encodeURIComponent(JSON.stringify(this.extend)) + "&v=" + Date.now() + "#/question-bch";
      }
      this.iframeUrl = this.urlAddCommonQuery(this.iframeUrl);
    },
    clickDownBtn: function clickDownBtn() {
      if (this.type === 'bottom' && this.isComplete === 1) {
        // 提交后不可再点击
        return null;
      }
      this.updateIframeUrl(); // 点击时更新iframe连接
      if (this.openType && (adapter.in('zz') || adapter.in('zlj'))) {
        // 端内且配置了this.openType
        var needNewWindow = [1, 3].includes(this.openType); // 新全屏webview、新半屏webview需要设置needNewWindow
        var skipUrl = [2, 3].includes(this.openType) ? this.dealHalfVerQuery(this.iframeUrl) : this.iframeUrl; // location.href 和半屏的情况需要补充半屏参数
        if (needNewWindow) {
          skipUrl = "zhuanzhuan://jump/core/web/jump?url=" + encodeURIComponent(skipUrl);
        }
        return adapter.skipToUrl({
          targetUrl: skipUrl,
          needNewWindow: needNewWindow
        });
      }
      if (this.outAppOpenType && !(adapter.in('zz') || adapter.in('zlj'))) {
        if (this.outAppOpenType === 2) {
          return adapter.skipToUrl({
            targetUrl: this.iframeUrl
          });
        }
      }
      this.showPop = true;
    }
  },
  render: function render(h) {
    var _this5 = this;
    var isCompleteAndIsHelp = this.isComplete === 1 && this.isHelp === 1;
    var isCompleteAndIsNotHelp = this.isComplete === 1 && this.isHelp === 0;
    return h("div", {
      "attrs": {
        "id": this.currentContainerId
      },
      "class": bem('wrap'),
      "style": {
        display: this.isShow !== 0 || this.preview ? 'unset' : 'none'
      }
    }, [this.type === 'bottom' && h("div", {
      "class": bem('type1')
    }, [h("div", {
      "class": bem('type1-content-wrap')
    }, [h("div", {
      "class": bem('type1-content', {
        'active-up': isCompleteAndIsHelp,
        'active-down': isCompleteAndIsNotHelp
      })
    }, [this.isComplete === 0 && h("div", {
      "class": bem('type1-line')
    }), (isCompleteAndIsHelp || this.isComplete !== 1) && h("div", {
      "class": bem(['type-item', 'type1-left']),
      "on": {
        "click": this.clickUpBtn
      }
    }, [h("img", {
      "attrs": {
        "src": "" + (isCompleteAndIsHelp ? 'https://pic1.zhuanstatic.com/zhuanzh/ae73fc2a-43b3-4d59-a6b9-b2cbc15856e5.png' : 'https://pic6.zhuanstatic.com/zhuanzh/de54cfea-c9b8-443e-b559-0f80b2856c50.png')
      },
      "class": bem(['img-icon', 'img-up'])
    }), "\u6709\u5E2E\u52A9"]), (isCompleteAndIsNotHelp || this.isComplete !== 1) && h("div", {
      "class": bem(['type-item', 'type1-right']),
      "on": {
        "click": this.clickDownBtn
      }
    }, [h("img", {
      "attrs": {
        "src": "" + (isCompleteAndIsNotHelp ? 'https://pic6.zhuanstatic.com/zhuanzh/cb4690ee-5ed3-4fdb-b84f-8d44150695aa.png' : 'https://pic6.zhuanstatic.com/zhuanzh/20fa0a9c-f617-49ae-84f3-79d96212a3b9.png')
      },
      "class": bem(['img-icon', 'img-down'])
    }), "\u65E0\u5E2E\u52A9"])])])]), this.type === 'embed' && h("div", {
      "class": bem('type2')
    }, [h("div", {
      "class": bem('type2-content')
    }, [h("div", {
      "class": bem('type2-title')
    }, [this.title || '以上看到的对比内容对你有帮助吗？']), h("img", {
      "attrs": {
        "src": "https://pic5.zhuanstatic.com/zhuanzh/e17328da-4ac3-4d7b-b428-feec48015f1a.png"
      },
      "class": bem('type2-close'),
      "on": {
        "click": this.clickClose
      }
    }), h("div", {
      "class": bem('type2-btn')
    }, [h("div", {
      "class": bem(['type2-item', 'type2-left']),
      "on": {
        "click": this.clickUpBtn
      }
    }, [h("img", {
      "attrs": {
        "src": "https://pic6.zhuanstatic.com/zhuanzh/de54cfea-c9b8-443e-b559-0f80b2856c50.png"
      },
      "class": bem(['img-icon', 'img-up'])
    }), "\u6709\u5E2E\u52A9"]), h("div", {
      "class": bem(['type2-item', 'type2-right']),
      "on": {
        "click": this.clickDownBtn
      }
    }, [h("img", {
      "attrs": {
        "src": "https://pic6.zhuanstatic.com/zhuanzh/20fa0a9c-f617-49ae-84f3-79d96212a3b9.png"
      },
      "class": bem(['img-icon', 'img-down'])
    }), "\u65E0\u5E2E\u52A9"])])])]), this.type === 'issus' && h("div", {
      "class": bem('type3')
    }, [h("div", {
      "class": bem('type3-btn'),
      "on": {
        "click": this.clickDownBtn
      }
    }, [h("img", {
      "attrs": {
        "src": "https://pic6.zhuanstatic.com/zhuanzh/46b7c935-7c6a-4c5e-a48e-bb2c51e1b0a0.png"
      },
      "class": bem(['type3-img'])
    }), this.title || '遇到问题？'])]), this.$slots.default && h("span", {
      "on": {
        "click": this.clickDownBtn
      }
    }, [this.slots()]), h(_actionPicker.default, {
      "attrs": {
        "title": "意见反馈",
        "showBtn": false,
        "position": this.position,
        "get-container": this.getContainer,
        "show-back": !!this.canBack && Number(this.canBack) === 1,
        "customPopStyle": this.customPopStyle
      },
      "ref": "actionPicker",
      "on": {
        "back": function back() {
          _this5.showPop = false;
        }
      },
      "model": {
        value: _this5.showPop,
        callback: function callback($$v) {
          _this5.showPop = $$v;
        }
      }
    }, [h("iframe", {
      "class": bem(['iframe']),
      "style": {
        height: "calc(" + this.popHeight + "vh - 10.42vh)",
        width: '100%',
        border: 'none'
      },
      "attrs": {
        "src": this.iframeUrl
      }
    })])]);
  }
});
exports.default = _default;